import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import {Observable} from 'rxjs';
import {AuthService} from '../services/auth.service';
import {map, take, tap} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class AuthRedirectGuard  {
    constructor(private auth: AuthService, private router: Router) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ):
        | Observable<boolean | UrlTree>
        | Promise<boolean | UrlTree>
        | boolean
        | UrlTree {
        return this.auth.token$.pipe(
            take(1),
            map((token) => !token),
            tap((notAuthenticated) => {
                if (!notAuthenticated) {
                    console.error('You are already authenticated.');
                    this.router.navigate(['/home'], {
                        queryParams: { returnUrl: state.url },
                    });
                }
            })
        );
    }
}
